<template>
  <div class="poster-wrap">
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加海报
    </el-button>
    <el-dialog title="添加海报" width="1200px" :visible.sync="dialogVisible">
      <el-form ref="form" label-width="100px">
        <el-form-item label="上传背景：">
          <upload @uploaded="imgBack"></upload>
        </el-form-item>
      </el-form>
      <div class="creat-poster">
        <div class="posback">
          <img :src="imageUrls" class="backimg" />
          <div
            class="qrimg"
            :style="{
              width: position.qrCodeWidth + 'px',
              left: position.qrCodeX + 'px',
              top: position.qrCodeY + 'px',
              height: position.qrCodeHeight + 'px'
            }"
          ></div>
        </div>
        <div class="qr-setting" v-if="imageUrls">
          <p>二维码位置设置：</p>
          <el-form ref="forms" label-width="50px">
            <el-form-item label="X：" prop="imageUrl">
              <el-input-number v-model="position.qrCodeX"></el-input-number>
            </el-form-item>
            <el-form-item label="Y：" prop="imageUrl">
              <el-input-number v-model="position.qrCodeY"></el-input-number>
            </el-form-item>
            <el-form-item label="宽：" prop="imageUrl">
              <el-input-number v-model="position.qrCodeWidth"></el-input-number>
            </el-form-item>
            <el-form-item label="高：" prop="imageUrl">
              <el-input-number
                v-model="position.qrCodeHeight"
              ></el-input-number>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSave()">保存</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Upload from 'components/upload';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      imageUrls: '',
      position: {
        qrCodeY: '',
        qrCodeX: '',
        qrCodeWidth: '',
        qrCodeHeight: ''
      },
      dialogVisible: false
    };
  },
  methods: {
    ...mapActions('poster', ['uploadPoster']),
    imgBack(data) {
      this.imageUrls = data;
    },
    handleSave() {
      this.uploadPoster({
        basicUrl: this.imageUrls,
        posterType: 1,
        ...this.position
      })
        .then((res)=> {
          if(res.code==0){
            this.$message.success('操作成功！');
          this.$emit('refresh');
          this.imageUrls=''
          }
        
        })
        .finally(() => {
          this.dialogVisible = false;
        });
    }
  },
  components: {
    Upload
  }
};
</script>
<style lang="less">
.creat-poster {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .posback {
    position: relative;
    .qrimg {
      position: absolute;
      background: black;
      // border:6px solid #fff;
    }
  }
}
.qr-setting {
  border: 1px solid #ddd;
  padding: 50px;
  margin-left: 30px;
  p {
    text-align: center;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    .el-button {
      width: 100%;
    }
  }
}
.backimg{
  width: 300px;
}
</style>
